import { Injectable, signal } from '@angular/core';
import { ProjectAggregateRequest } from '../enums/projectAggregate';
import { ProjectAggregateService } from './project-aggregate.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectAggregateStoreService {
    private projectAggregateRequest = signal<ProjectAggregateRequest>({} as ProjectAggregateRequest);

  setProjectAggregateRequest(data: Partial<ProjectAggregateRequest>) {
          this.projectAggregateRequest.update(current => ({ ...current, ...data }));
      }

      getProjectAggregateRequest() {
        return this.projectAggregateRequest();
      }
}
